import { Record } from 'immutable'

export interface IOnlineListingService {
  readonly link: string
  readonly name: string
  readonly required: boolean
}

const OnlineListingServiceRecord = Record({
  link: '',
  name: '',
  required: false,
})

export class OnlineListingService extends OnlineListingServiceRecord
  implements IOnlineListingService {
  public static fromJS(initialState?: Partial<IOnlineListingService>) {
    return new OnlineListingService(initialState)
  }

  public readonly link: string
  public readonly name: string
  public readonly required: boolean

  constructor(props?: Partial<OnlineListingService>) {
    props ? super(props) : super()
  }
}
